import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { Expose, Model, ModelId } from '@core/shared/model';
import { UserConversion } from '../constants';
let ConvertUserResponse = /*#__PURE__*/(() => {
  let ConvertUserResponse = class ConvertUserResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Boolean)], ConvertUserResponse.prototype, "success", void 0);
  __decorate([Expose(), __metadata("design:type", String)], ConvertUserResponse.prototype, "error", void 0);
  ConvertUserResponse = __decorate([ModelId("ConvertUserResponse") // auto-generated by generate-model-ids
  ], ConvertUserResponse);
  return ConvertUserResponse;
})();
export { ConvertUserResponse };
// check is case-insensitive, but note that returned value letters will be as saved in the database!
let AdminConvertUserRequest = /*#__PURE__*/(() => {
  let AdminConvertUserRequest = class AdminConvertUserRequest extends Model {
    static {
      this.Response = ConvertUserResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", Number)], AdminConvertUserRequest.prototype, "userId", void 0);
  __decorate([Expose(), __metadata("design:type", String)], AdminConvertUserRequest.prototype, "conversionType", void 0);
  AdminConvertUserRequest = __decorate([AppRequest('admin/users', 'convert', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("AdminConvertUserRequest") // auto-generated by generate-model-ids
  ], AdminConvertUserRequest);
  return AdminConvertUserRequest;
})();
export { AdminConvertUserRequest };
let ManagerConvertUserRequest = /*#__PURE__*/(() => {
  let ManagerConvertUserRequest = class ManagerConvertUserRequest extends Model {
    static {
      this.Response = ConvertUserResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", Number)], ManagerConvertUserRequest.prototype, "userId", void 0);
  __decorate([Expose(), __metadata("design:type", String)], ManagerConvertUserRequest.prototype, "conversionType", void 0);
  ManagerConvertUserRequest = __decorate([AppRequest('manager/users', 'convert', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['managedUserIds']
  }), ModelId("ManagerConvertUserRequest") // auto-generated by generate-model-ids
  ], ManagerConvertUserRequest);
  return ManagerConvertUserRequest;
})();
export { ManagerConvertUserRequest };